module.exports = __webpack_public_path__ + "static/img/psn_require.2d819fda.png";